import { useMutation } from "../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks";
import { SaveSpotbuildGeneratedIdsDocument, useGetSpotbuildGeneratedIdsLazyQuery as _useGetSpotbuildGeneratedIdsLazyQuery, useUpdateFreeTrialOnboardingConfigMutation as _useUpdateFreeTrialOnboardingConfigMutation, } from './generated/graphql-types';
export const useSaveSpotbuildGeneratedIds = () => {
    const [saveSpotbuildGeneratedIds, { data, error, loading }] = useMutation(SaveSpotbuildGeneratedIdsDocument);
    return {
        data: data?.saveSpotbuildGeneratedIds,
        error,
        loading,
        saveSpotbuildGeneratedIds: (sparkflowMappings) => saveSpotbuildGeneratedIds({
            variables: {
                sparkflow_mappings: sparkflowMappings,
            },
        }),
    };
};
export const useGetSpotbuildGeneratedIds = () => {
    const [getSpotbuildGeneratedIds, { data, error, loading },] = _useGetSpotbuildGeneratedIdsLazyQuery({
        fetchPolicy: 'network-only',
    });
    return {
        data: data?.getSpotbuildGeneratedIds,
        error,
        loading,
        getSpotbuildGeneratedIds,
    };
};
export const useUpdateFreeTrialOnboardingMutation = () => {
    const [Session__updateFreeTrialOnboardingConfig, { data, loading, error },] = _useUpdateFreeTrialOnboardingConfigMutation();
    return {
        Session__updateFreeTrialOnboardingConfig: (freeTrialOnboardingSeen, onboardingLocationSelected, edgeOnboardingCompleted) => Session__updateFreeTrialOnboardingConfig({
            variables: {
                freeTrialOnboardingSeen,
                onboardingLocationSelected,
                edgeOnboardingCompleted,
            },
        }),
        data,
        error,
        loading,
    };
};
//# sourceMappingURL=onboarding.service.js.map